import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import PopupCloseButton from "@components/elements/PopupCloseButton";
import { gamePopState } from "@stores/popup";
import playSound from "@/sound";
import { useAtom, useAtomValue } from "jotai";
import { currentPageState } from "@stores/vars";
import GameGuide from "./GameGuide";
import GameCard from "./GameCard";
import GameTrain from "./GameTrain";
import GameDonut from "./GameDonut";
import anime from "animejs";

const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #606680;
  z-index: 105;
  animation: fullDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  .swiper {
    overflow: hidden;
    border-radius: 50px;
  }
`;

const Game = () => {
  const [curInfo, setInfo] = useAtom(gamePopState);
  const currentPage = useAtomValue(currentPageState);
  const onClose = () => {
    const closeButton = document.querySelector(".gamePopButton");
    closeButton.classList.remove("in");
    // eslint-disable-next-line no-unused-vars
    const a = closeButton.offsetHeight;
    if (!curInfo.type) {
      setInfo({
        open: false,
        isPlay: false,
        data: null,
        categoryKey: null,
      });
    } else {
      closeButton.classList.add("in");

      playSound.bgm(null);
      setInfo({
        ...curInfo,
        isPlay: false,
        type: undefined,
      });
    }
  };

  const onStart = (type) => {
    window.__currentGameType = type;
    setInfo({
      open: true,
      isPlay: true,
      type: type,
      categoryKey: curInfo.categoryKey,
      data: curInfo.data,
    });
  };

  const renderActivity = useMemo(() => {
    //playSound.effect(swapSound);
    const currentType = curInfo.type;
    if (currentType === "card") {
      return <GameCard data={curInfo} endClick={onClose} />;
    } else if (currentType === "train") {
      return <GameTrain data={curInfo} endClick={onClose} />;
    } else if (currentType === "donut") {
      return <GameDonut data={curInfo} endClick={onClose} />;
    } else {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curInfo]);

  useEffect(() => {
    window.__currentGameType = undefined;
    return () => {
      window.__currentGameType = undefined;
      playSound.bgm(null);
      if (currentPage === "main") {
        playSound.bgm(require("@assets/sounds/bgm/main.mp3"));
      } else if (currentPage === "book") {
        playSound.bgm(require("@assets/sounds/bgm/book.mp3"));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap className="pop-activity">
      {!curInfo.isPlay && <GameGuide onStart={onStart} />}
      <div>{curInfo.isPlay && renderActivity}</div>
      <PopupCloseButton onClick={onClose} cName="gamePopButton" />
    </Wrap>
  );
};

export default Game;
